import { render, staticRenderFns } from "./CompanyTariffTypeSelect.vue?vue&type=template&id=7fec00ae&scoped=true&"
import script from "./CompanyTariffTypeSelect.vue?vue&type=script&lang=js&"
export * from "./CompanyTariffTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fec00ae",
  null
  
)

export default component.exports